import { IWebchatTokensRepository } from 'modules/webchat/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

/**
 * Pede ao BFF o token da sala. O BFF repassa a sala à Callbell no cookie de
 * sessão, que o navegador não deixaria o site trocar. Para o cliente logado a
 * sala vem da sessão dele no BFF (rota autenticada), não do navegador.
 */
export default class CallbellWebchatTokensRepository
  implements IWebchatTokensRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public issue: IWebchatTokensRepository['issue'] = ({
    channelUuid,
    sessionId,
  }) => this.request('chat/sessao', { canal: channelUuid, sessao: sessionId });

  public issueForCustomer: IWebchatTokensRepository['issueForCustomer'] = ({
    channelUuid,
  }) => this.request('chat/sessao/cliente', { canal: channelUuid });

  private async request(path: string, body: Record<string, string>) {
    const response = await this.httpProvider.post<{ token?: unknown } | null>(
      path,
      body,
    );

    const token = response?.token;

    if (typeof token !== 'string' || !token) {
      throw new Error('O BFF não devolveu o token do Webchat');
    }

    return token;
  }
}
